var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.941176414489746, 0.5882352590560913)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.06 0.00 C 4.12 0.00 1.76 2.35 1.76 5.29 L 1.76 7.65 C 0.76 7.65 0.00 8.41 0.00 9.41 L 0.00 17.06 C 0.00 18.06 0.76 18.82 1.76 18.82 L 12.35 18.82 C 13.35 18.82 14.12 18.06 14.12 17.06 L 14.12 9.41 C 14.12 8.41 13.35 7.65 12.35 7.65 L 12.35 5.29 C 12.35 2.35 10.00 0.00 7.06 0.00 M 12.94 9.41 L 12.94 17.06 C 12.94 17.41 12.71 17.65 12.35 17.65 L 1.76 17.65 C 1.41 17.65 1.18 17.41 1.18 17.06 L 1.18 9.41 C 1.18 9.06 1.41 8.82 1.76 8.82 L 2.35 8.82 L 11.76 8.82 L 12.35 8.82 C 12.71 8.82 12.94 9.06 12.94 9.41 M 2.94 7.65 L 2.94 5.29 C 2.94 3.00 4.76 1.18 7.06 1.18 C 9.35 1.18 11.18 3.00 11.18 5.29 L 11.18 7.65 L 2.94 7.65",
    fill: "#4b1498",
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.235294342041016, 11.17647111415863)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.76 0.00 C 0.76 0.00 0.00 0.76 0.00 1.76 C 0.00 2.53 0.47 3.18 1.18 3.41 L 1.18 4.71 C 1.18 5.06 1.41 5.29 1.76 5.29 C 2.12 5.29 2.35 5.06 2.35 4.71 L 2.35 3.41 C 3.06 3.18 3.53 2.53 3.53 1.76 C 3.53 0.76 2.76 0.00 1.76 0.00 M 1.76 2.35 C 1.41 2.35 1.18 2.12 1.18 1.76 C 1.18 1.41 1.41 1.18 1.76 1.18 C 2.12 1.18 2.35 1.41 2.35 1.76 C 2.35 2.12 2.12 2.35 1.76 2.35",
    fill: "#4b1498",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.2fb5a1119e3f678eb0b2c8efe3a4ddd3.svg";
export { ForwardRef as ReactComponent };